module.exports = __webpack_public_path__ + "images/euroinsurancesed0dfd9d197984668f9de87d59f267d8.png";